import PageHero from '@/components/site/PageHero';
import SectionHeading from '@/components/site/SectionHeading';
import CtaBand from '@/components/site/CtaBand';
import Icon from '@/components/site/Icon';
import StatsBand from '@/components/sections/StatsBand';
import Reveal from '@/components/ui/Reveal';
import { usePage } from '@site/content';

export default function Training() {
  const { hero, intro, benefits, programmes, stats } = usePage('training');
  return (
    <>
      <PageHero {...hero} seoTitle="Fire & Safety Training" />

      <section className="py-16 sm:py-24">
        <div className="site-container grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
          <div>
            <SectionHeading eyebrow={intro.eyebrow} title={intro.title} />
            <p className="mt-5 text-pretty leading-relaxed text-ink-600">{intro.text}</p>
            <ul className="mt-8 grid grid-cols-2 gap-3">
              {benefits.map((b) => (
                <li key={b.title} className="flex items-center gap-3 rounded-2xl border border-[var(--app-border)] bg-white p-4">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-flame-x">
                    <Icon name={b.icon} className="h-5 w-5 text-white" />
                  </span>
                  <span className="text-sm font-medium leading-tight text-ink-800">{b.title}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="grid grid-cols-5 gap-3">
            <Reveal className="col-span-3">
              <img src={intro.image} alt={intro.imageAlt} loading="lazy" className="aspect-[3/4] h-full w-full rounded-[1.5rem] object-cover" />
            </Reveal>
            <Reveal className="col-span-2 self-end" delay={0.1}>
              <img src={intro.image2} alt={intro.image2Alt} loading="lazy" className="aspect-[3/4] w-full rounded-[1.5rem] object-cover" />
            </Reveal>
          </div>
        </div>
      </section>

      <StatsBand stats={stats} />

      <section className="py-16 sm:py-24">
        <div className="site-container">
          <SectionHeading eyebrow={programmes.eyebrow} title={programmes.title} align="center" />
          <ol className="mt-12 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {programmes.items.map((p, i) => (
              <li key={p} className="flex items-center gap-4 rounded-2xl border border-[var(--app-border)] bg-white p-4 transition-colors hover:border-primary-300">
                <span className="font-display text-2xl font-extrabold text-primary-600">{String(i + 1).padStart(2, '0')}</span>
                <span className="text-sm font-medium leading-snug text-ink-800">{p}</span>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <CtaBand />
    </>
  );
}
